"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Witness = exports.WitnessType = exports.SigHash = void 0;
var Serialization_1 = require("../../../Handlers/Serialization");
var SigHash;
(function (SigHash) {
    SigHash[SigHash["TxHash"] = 1] = "TxHash";
    SigHash[SigHash["FollowingWitnesses"] = 3] = "FollowingWitnesses";
})(SigHash = exports.SigHash || (exports.SigHash = {}));
var WitnessType;
(function (WitnessType) {
    WitnessType[WitnessType["PKWitness"] = 1] = "PKWitness";
    WitnessType[WitnessType["ContractWitness"] = 2] = "ContractWitness";
})(WitnessType = exports.WitnessType || (exports.WitnessType = {}));
var Witness = /** @class */ (function () {
    function Witness(identifier) {
        this.identifier = identifier;
    }
    Witness.prototype.toJson = function () {
        return {
            identifier: this.identifier
        };
    };
    Witness.prototype.getSize = function () {
        return Serialization_1.getSizeOfVarInt(this.identifier);
    };
    Witness.publicKeySize = 33;
    Witness.signatureSize = 64;
    return Witness;
}());
exports.Witness = Witness;
//# sourceMappingURL=Witness.js.map